export default "__VITE_ASSET__CVCmwOZE__"